<template>
    <div class="text-center d-flex flex-column text-h6 text-grey-lighten-1 py-10">
        <template v-if="isShowNewOrderRequestBtn">
            <span v-text="$t('no_found_label.didnt_find')" />
            <span class="mt-2">
                {{ $t('no_found_label.send') }}
                <v-btn dense class="mx-1" :color="'primary'" @click="newOrderRequestModal = true">
                    {{ $t('no_found_label.reservation_request') }}
                </v-btn>
                {{ $t('no_found_label.assist') }}
            </span>
        </template>
        <new-order-request-modal v-model="newOrderRequestModal" />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import NewOrderRequestModal from '~src/components/account/modals/newOrderRequest/newOrderRequestModal.src'

    @Component({
        components: {
            NewOrderRequestModal,
        },
    })
    export class NoOffersLabel extends Vue {
        newOrderRequestModal = false

        get isShowNewOrderRequestBtn() {
            return true
        }
    }

    export default NoOffersLabel
</script>
